import React, { memo } from "react";
import { formats } from "investira.sdk";
import { HighchartsReact } from "investira.react.charts";
import { ATIVO_TIPO } from "@investirapri/financa.js/lib/enums";

const TipoAtivoChart = memo((props) => {
  const { data = [] } = props;

  const processData = (data) => {
    const xMainData = [];

    Object.entries(data).forEach(([key, item], xIndex) => {
      xMainData.push({
        name: ATIVO_TIPO[key].descricao,
        y: item.percentual,
        dataLabels: {
          color: "#FFFFFF",
        },
        metadata: {
          name: key,
          ...item,
          valor: formats.formatNumber(item.valor, 2, true, true),
        },
      });
    });

    return xMainData;
  };

  const xOptions = {
    chart: {
      type: "pie",
      height: "320px",
    },
    title: false,
    plotOptions: {
      pie: {
        innerSize: "50%",
        borderColor: "#2e2e46",
        borderWidth: 2,
        shadow: false,
        center: ["50%", "50%"],
        dataLabels: {
          enabled: true,
          useHTML: true,
          formatter: function () {
            return `<span style="color: #FFFFFF; text-decoration: none;">${this.point.name}</span>`;
          },
          style: {
            color: "#FFFFFF",
            textOutline: "none",
          },
        },
      },
    },
    tooltip: {
      useHTML: true,
      style: {
        zIndex: 1000,
      },
      pointFormat: `Financeiro: <b>{point.metadata.valor}</b><br>Percentual: <b>{point.metadata.percentual}%</b>`,
    },
    series: [
      {
        name: "Duration",
        colorByPoint: true,
        data: processData(data),
        dataLabels: {
          color: "#ffffff",
          enabled: true,
          style: {
            fontSize: "11px", // Reduz o tamanho da fonte
          },
        },
      },
    ],
  };

  return <HighchartsReact options={xOptions} drilldown />;
});

export default TipoAtivoChart;
